export default __webpack_public_path__ + "static/media/PEINTURE-DE BALISAGE.b23ebeb2.svg";